import { useEffect, useState } from "react";
import CustomerCreationDialog from "./CustomerCreationDialog";
import "./braintree.scss";
import CreditCardForm from "./CreditCardForm";
import HostedFieldsCreate from "./HostedFieldsCreate";
import clockImage from "../../../default_images/clock.svg";
import lsKeys from "../../../default_values/defaultKeys";
import { useAccountStore } from "../../../../stores/accountStore";
import { shallow } from "zustand/shallow";
import TeambookDialog from "../../../default_components/TeambookDialog";
import PropTypes from "prop-types";
import LoadingComponent from "../../../default_components/LoadingComponent";

const SubscriptionModal = ({ open, subscribeRequest, loading, closeModal, selectedPlan, createManualSubscription }) => {
  const isDarkTheme = localStorage.getItem(lsKeys.THEME) === "dark";
  const [account] = useAccountStore((state) => [state.account], shallow);

  const [token, setToken] = useState();
  const [customerCreated, setCustomerCreated] = useState(!!account.braintree_customer_id);
  const [loadingText, setLoadingText] = useState();
  const [errorText, setErrorText] = useState();
  const [userData, setUserData] = useState({});

  useEffect(
    () =>
      HostedFieldsCreate(setToken, selectedPlan, subscribeRequest, setLoadingText, setErrorText, isDarkTheme, userData),
    [customerCreated]
  );

  useEffect(() => {
    setLoadingText(null);

    setTimeout(() => setErrorText(null), 4000);
  }, [errorText]);

  if (loading) {
    return <LoadingComponent />;
  }

  if (!customerCreated) {
    return (
      <CustomerCreationDialog
        open={open}
        closeModal={closeModal}
        setCustomerCreated={setCustomerCreated}
        setUserData={setUserData}
        createManualSubscription={createManualSubscription}
      />
    );
  }

  return (
    <TeambookDialog
      title={"Add a new card"}
      open={open}
      onClose={closeModal}
      withCloseButton
      size={"small"}
      content={
        <>
          {token ? <CreditCardForm /> : <LoadingComponent />}

          {loadingText && (
            <p className="blink-text">
              {loadingText} <img src={clockImage} />
            </p>
          )}

          {errorText && <p className="error-text" style={{maxWidth: "400px"}}>{errorText}</p>}
        </>
      }
    />
  );
};

SubscriptionModal.propTypes = {
  open: PropTypes.bool.isRequired,
  subscribeRequest: PropTypes.func.isRequired,
  loading: PropTypes.bool.isRequired,
  closeModal: PropTypes.func.isRequired,
  selectedPlan: PropTypes.object.isRequired,
  createManualSubscription: PropTypes.func.isRequired,
};

export default SubscriptionModal;
